export default "__VITE_ASSET__CRTLcBwE__"